import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Visible breadcrumb trail. Pair with usePageMeta({breadcrumbs}) for schema.
 * Expects: items = [{ label, href }]  (last item without href = current page)
 */
const Breadcrumbs = ({ items = [] }) => {
  if (items.length < 2) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      className="max-w-7xl mx-auto px-4 sm:px-6 pt-24 sm:pt-28"
      data-testid="breadcrumbs"
    >
      <ol className="flex flex-wrap items-center gap-1.5 text-[11px] sm:text-xs font-mono-ui uppercase tracking-[0.14em] text-white/55">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.label + i} className="flex items-center gap-1.5">
              {i === 0 && <Home className="h-3 w-3 shrink-0" aria-hidden="true" />}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="hover:text-white transition-colors"
                  data-testid={`breadcrumb-link-${i}`}
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-white/85" aria-current={isLast ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <ChevronRight className="h-3 w-3 text-white/35" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
